import axios from 'axios';
import { DC_FORM_SENDER_APPLICATIONS_PASSPORT } from '@alfa-bank/site-dc-env-config';

import type { IPassportCheckResponse } from '../models/api';
import type { IPassportStepData } from '../models/form-data';

export const passportCheckApi = ({ appId, businessUid, passportFullNumber }: IPassportStepData) => {
    return axios.post<IPassportCheckResponse>(
        DC_FORM_SENDER_APPLICATIONS_PASSPORT({ appId }),
        {
            passportFullNumber,
        },
        {
            headers: {
                BusinessUid: businessUid,
            },
        }
    );
};
